import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FileLink, Img } from 'components/misc'
import { MaterialLoader } from 'components/loaders'
import styles from './file-thumb.styl'
import getFileType from 'utils/getFileType'

// const supportedFileTypes = [
//   'doc',
//   'ppt',
//   'docx',
//   'pptx',
//   'pdf',
//   'mp4',
//   'xls',
//   'xlsx'
// ]

@connect(({ auth }) => ({
  user: auth.user
}))
class FileThumb extends Component {
  static propTypes = {
    fileUrl: PropTypes.string,
    loading: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    clickable: true,
    loading: false,
    simple: false,
    loadingSize: 30,
    className: '',
    fileClassName: '',
    nameClassName: ''
  }

  state = {
    isOpen: false
  }

  render() {
    const { fileUrl, loading, className, user } = this.props
    const type = getFileType(fileUrl)

    if (!fileUrl) {
      return null
    }

    let content = null

    const blobCode = get(user, 'blobAccessAuthorizationCode')

    const operator = fileUrl.includes('?') ? '&' : '?'
    const suffix = `${operator}authorizationCode=${blobCode}`

    const isImage =
      type &&
      (type.toLowerCase() === 'jpeg' ||
        type.toLowerCase() === 'png' ||
        type.toLowerCase() === 'jpg') &&
      fileUrl

    if (isImage) {
      content = <Img src={fileUrl} asGallery defaultWidth={1000} />
    } else {
      content = (
        <FileLink
          src={`${fileUrl}${suffix}`}
          type={type}
          icoClass={styles.ico}
          typeClass={styles.type}
        />
      )
    }

    return (
      <span className={`${className} ${styles.thumb}`}>
        {loading && <MaterialLoader small inline className={styles.loader} />}
        {!loading && content}
      </span>
    )
  }
}

export default FileThumb
